import React from "react";
import {Redirect} from "react-router";
//import ReactDOM from "react-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import PatientSubsribeForm from "components/Forms/PatientForm/AddExistingForm.jsx";
import MasterTestForm from "components/Forms/MasterTestForm/MasterTestForm.jsx";
import SearchComponent from "components/Search/AutoCompletePatient.jsx";

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    }
};

class AddMasterTest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addNew: false,
            addExisting: false,
            alert: null,
            open: "true",
            patient_ID: '',
            subscription: 'notdone'
        }
        this.hideAlert = this.hideAlert.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this);
    };




    hideAlert() {
        this.setState({
            alert: null
        });
    }


    CreateAlert(reason) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{reason}</DialogTitle>

                    <DialogActions>
                        <Button onClick={this.hideAlert}>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }


    render() {

        return (
            <div>
                {this.state.alert}
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" text>
                                <CardText color="info">
                                    <h4 >Add Master Test</h4>
                                </CardText>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>

                                    <GridItem xs={12} md={12} sm={12}>
                                        <MasterTestForm id={this.props}/>
                                    </GridItem>

                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>);
    }

}

export default withStyles(styles)(AddMasterTest);



// WEBPACK FOOTER //
// ./src/views/Tests/AddMasterTest.jsx